import { HelpDeskProvider } from 'context/HelpDeskContext';
import React from 'react';
import ReactDOM from 'react-dom';
import EmissionProvider from 'shared/components/EmissionProvider';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { HelpDeskTooltipProvider } from 'context/HelpDeskTooltipContext';
import { UserContextProvider } from 'context/UserContext';
import { ParentOrganizationProvider } from 'context/ParentOrganisationContext';
import { LocationsDataProvider } from 'context/LocationsDataContext';

ReactDOM.render(
  <React.StrictMode>
    <EmissionProvider>
      <HelpDeskProvider>
        <HelpDeskTooltipProvider>
          <UserContextProvider>
            <ParentOrganizationProvider>
              <LocationsDataProvider>
                <App />
              </LocationsDataProvider>
            </ParentOrganizationProvider>
          </UserContextProvider>
        </HelpDeskTooltipProvider>
      </HelpDeskProvider>
    </EmissionProvider>
  </React.StrictMode>,
  document.getElementById('root')
);

serviceWorker.unregister();
